module.exports = __webpack_public_path__ + "img/m.28c2b565.webp";